import _ from 'lodash';

export const getContacts = state => state.customer.profile.contacts.list;
export const getNotEmptyContacts = state => _.filter(getContacts(state), function(o) { return o.comment !== ""; });
export const isLoading = state => state.customer.profile.contacts.isLoading;
export const getContact = state => idx => getContacts(state)[idx];
export const getSelectedContact = state => state.customer.profile.contacts.selectedIndex !== undefined ? getContacts(state)[state.customer.profile.contacts.selectedIndex] : undefined;
export const isSelected = state => idx => state.customer.profile.contacts.selectedIndex === idx;
export const getNumberOfContacts = noOfContacts => state => _.take(getContacts(state), noOfContacts);
export const activePanelId = state => state.customer.profile.contacts.activePanelId;
export const isButtonEnabled = state => state.customer.profile.contacts.buttonEnabled;
export const isPosting = state => state.customer.profile.contacts.isPosting;